<template>
  <div class="about container">
    <div>
      <van-sticky>
        <van-nav-bar @click-right="logout()" right-text="Logout" >
          <template #title>
            <a href="/">
              <div style="display: flex;">
                <img src="/image/jkn.png" style="max-height: 40px;" alt="">
                <div style="font-weight: bold;font-size:1.9em;color:black;"></div>
              </div>
            </a>
          </template>
        </van-nav-bar>
      </van-sticky>
    </div>
    <div style="margin-bottom : 40px;">

  <img style="max-width : 100%;width : 100%;" src="/img/banner.jpeg" />
    <div style="text-align : center">
    <!-- <van-notice-bar text="Selamat, Antum Terdaftar sebagai Peserta" left-icon="volume-o" /> -->
    <h2 style="padding : 0 10px;">Selamat, Anda telah Terdaftar!</h2>
    </div>
    <van-cell>
    <h2>FILM JEJAK KHILAFAH DI NUSANTARA</h2>
    </van-cell>
  
    <van-tabs v-model="active" scrollspy sticky>

        <van-tab title="Detil" name="0">
            <van-cell-group title="Detil Acara">
                <van-cell title="Waktu" :value="getDateTime()">

                </van-cell>
                <van-cell title="Penyelenggara" :value="event.nama_penyelenggara">

                </van-cell>
            </van-cell-group>
        </van-tab>
        
        <van-tab title="Socmed JKDN" name="1">
            
            <van-cell-group title="Socmed JKDN">
                <van-cell>
                    
                    <div>
              <p> Alhamdulillah, kembali lagi di ruang tunggu ini.</p>

<p>Sekarang FILM JKDN sudah dirilis resmi kepada publik dengan kualitas FULL HD. silakan bagikan link di bawah kepada teman dan keluarga. Ayo kita ajak semuanya untuk menonton bareng FILM JKDN. Klik Masuk untuk menonton FILM.</p>

<p>Silakan juga untuk follow akun instagram kita dan telegram kita yang ada di ruang ini.</p>




                    </div>
         
                    <van-field readonly   class="copy-url" :value="`https://bit.ly/film-jkdn`" center >
  <template #button>
  <button :data-clipboard-text="`https://bit.ly/film-jkdn`" @click="$notify({message : 'Link telah dicopy', type : 'success'})" class="btn-copy van-button van-button--primary van-button--small"><div class="van-button__content"><span class="van-button__text">Copy</span></div></button>
  </template>
</van-field>
                </van-cell>
                <van-cell>
                <a target="_blank" href="http://t.me/jejakkhilafahdinusantara" class="van-button van-button--info van-button--normal van-button--block" style="color: rgb(255, 255, 255); background: #0088cc; border-color: #0088cc;"><div class="van-button__content"><span class="van-button__text">IKUTI TELEGRAM JKDN : t.me/jejakkhilafahdinusantarak</span></div></a>
                </van-cell>   
                <van-cell>
                <a target="_blank" href="https://www.instagram.com/jejakkhilafahdinusantara/?hl=da" class="van-button van-button--info van-button--normal van-button--block" style="color: rgb(255, 255, 255); background: rgb(193,53,132); border-color: rgb(193,53,132)"><div class="van-button__content"><span class="van-button__text">IKUTI IG JKDN : @jejakkhilafahdinusantara</span></div></a>
                </van-cell>   

                
                <!-- <van-cell>
                <a target="_blank" :href="`https://facebook.com/sharer.php?u=https://krm.li/p/${peserta.ref_url}`" class="van-button van-button--info van-button--normal van-button--block" style="color: rgb(255, 255, 255); background: rgb(66, 103, 178); border-color: rgb(66, 103, 178);"><div class="van-button__content"><span class="van-button__text">Share ke Facebook</span></div></a>
                </van-cell>
                <van-cell>
                <a target="_blank" :href="`https://twitter.com/intent/tweet?text=${tweet_share}&url=https://krm.li/p/${peserta.ref_url}`" class="van-button van-button--info van-button--normal van-button--block" style="color: rgb(255, 255, 255); background: rgb(29, 161, 242); border-color: rgb(29, 161, 242);"><div class="van-button__content"><span class="van-button__text">Share ke Twitter</span></div></a>
                </van-cell>
                <van-cell>
                <a target="_blank" :href="`https://api.whatsapp.com/send?text=${encodeURIComponent(wa_share)}`" class="van-button van-button--info van-button--normal van-button--block" style="color: rgb(255, 255, 255); background: rgb(37, 211, 102); border-color: rgb(37, 211, 102);"><div class="van-button__content"><span class="van-button__text">Share ke Whatsapp</span></div></a>
                </van-cell> -->
            </van-cell-group>
          
        </van-tab>
       
    </van-tabs>
    <van-submit-bar   style="position: fixed; left : auto; bottom : 0;  max-width: 100%;
        width: 640px;margin: 0 auto;"  button-text="Masuk" @submit="$router.push(roomLocation)">
    <template>
        <div>
        <span id="cta-masuk"   >
          <img  src="/img/KLIK.png" alt="">
        </span>
        <!-- <van-count-down v-if="time > 0" style="margin-right : 10px;" :time="time" >

        <template  v-slot="timeData">
        <span class="block">{{ timeData.days }} h</span>
    <span class="colon">:</span>
    <span class="block">{{ timeData.hours }} j</span>
    <span class="colon">:</span>
    <span class="block">{{ timeData.minutes }} mnt</span>
    <span class="colon">:</span>
    <span class="block">{{ timeData.seconds }} dtk</span>
  </template>

        </van-count-down> -->
        </div>
    </template>    
</van-submit-bar>
</div>
  </div>
</template>
<script>
import moment from 'moment'
import ClipboardJS from 'clipboard'
export default {
  data : ()=>({
      showCalendar: true,
      roomLocation : '/room-rijal',
            time: 0,
            referrer: document.referrer,
            show: false,
            option1: ['laki-laki', 'perempuan', 'semua'],
            active: '0',
            id_zone: 'WIB',
            wa_share : '',
            tweet_share : '',
            peserta_id : '',
            peserta : {},
            
            event: {
                title: '',
                nama_penyelenggara : 'JKDN Movie',
                waktu: new Date('2020-08-23 02:00:00'),
                images: [],
                tanya_usia: false,
                jumlah_peserta: 100
            },
  }),
  mounted(){

    new ClipboardJS('.btn-copy')
      var offset = new Date().getTimezoneOffset() / 60;

    if (offset == -8) {
        this.id_zone = 'WITA';
    }
    if (offset == -9) {
        this.id_zone = 'WIT';
    }
    this.event.waktu = moment(this.event.waktu).subtract(offset, 'hours').toDate();
    this.time = (this.event.waktu.getTime() - new Date().getTime());


            var peserta = localStorage.getItem('peserta');
            if(peserta)
            {
              this.peserta = JSON.parse(peserta)
              this.roomLocation =  (this.peserta.gender == 'laki-laki') ? '/room-rijal' : '/room-nisa'  
            }else{
              this.$router.push('/')
            }


  },
  methods:{
    logout()
    {
      localStorage.removeItem('peserta')
      this.$router.push('/')
    },
    loadPlayer() {
                var screenWidth = document.querySelector('#player').offsetWidth;
                var screenHeight = Math.floor(screenWidth / 16 * 9);


/*eslint-disable */
            new YT.Player('player', {
                height: screenHeight,
                width: screenWidth,
                videoId: 'TruKqhBaW7M',
                events: {
                    'onReady': (event) => {
                        // var iframe = document.querySelector('#player');
                        // var requestFullScreen = iframe.requestFullScreen || iframe
                        //     .mozRequestFullScreen || iframe
                        //     .webkitRequestFullScreen;
                    },
                    'onStateChange': (event) => {


                    }
                }
            });
            /*eslint-enable */


        },
            
            timeStringify() {
                return moment(this.event.waktu).format('D MMM YYYY');
            },
            dataTime() {
                var offset = new Date().getTimezoneOffset() / 60;
                return moment(moment(this.event.waktu).format('YYYY-MM-DD') + ' ' + this.time).add(offset,
                    'hours').format('YYYY-MM-DD HH:mm');
            },
            getTime() {
                return moment(this.event.waktu).format('HH:mm');
            },
            getDateTime() {

                return this.timeStringify() + ' ' + this.getTime() + ' ' + this.id_zone;

            },
  }
}
</script>

<style>
@keyframes mymove {
  0% {padding-right: 0px;}
  50% {padding-right: 40px;}
  100% {padding-right: 0px;}
}
#cta-masuk{
    animation: mymove 3s;
    padding-right : 10px;
  animation-iteration-count: infinite;
}
</style>